/**
 * @file 状态管理
 * @author  fangsimin
 * @date    2019-01-02 10:07:17
 * @last Modified by    fangsimin
 * @last Modified time  2020-02-09 21:26:08
 */

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        hasPermission: true, // 权限
        permissionList: [],
        permissionDialogVisible: false,
        lang: localStorage.lang || 'cn',
        userId: '',
        userName: '',
        createAccountInfo: {
            mediaList: [], // 开户选择的媒体平台
            accountInfoList: {}, // 账户信息列表
            targetSetting: {} // 目标设定
        },
        dowloadList: undefined,
        createDownloadJob: false,
        reportTemplateList: undefined,
        allTemporaryTemplateInfo: undefined,
        currentReportTemplateId: undefined,
        allExistTemplateInfo: undefined,
        tableDataLoading: false,
        chartDataLoading: false,
        bulkUploadCreative: {}
    },
    getters: {
        getTableDataLoading: (state, getters, rootState) => {
            return state.tableDataLoading;
        },
        getChartDataLoading: (state, getters, rootState) => {
            return state.chartDataLoading;
        },
        getLang: (state, getters, rootState) => {
            return state.lang;
        },
        getUserId: (state, getters, rootState) => {
            return state.userId || localStorage.getItem('userId');
        },
        getUserName: (state, getters, rootState) => {
            return state.userName;
        },
        getCreateAccountInfo: (state, getters, rootState) => {
            return state.createAccountInfo;
        },
        getPermissionDialogVisible: (state, getters, rootState) => {
            return state.permissionDialogVisible;
        },
        getDownloadList: (state, getters, rootState) => {
            return state.dowloadList;
        },
        getDownloadStatus: (state, getters, rootState) => {
            return state.createDownloadJob;
        },
        getReportTemplateList: (state, getters, rootState) => {
            return state.reportTemplateList;
        },
        getCurrentReportTemplateId: (state) => {
            return state.currentReportTemplateId;
        },
        getAllTemporaryTemplateList: (state) => {
            return state.allTemporaryTemplateInfo;
        },
        getAllExistTemplateList: (state) => {
            return state.allExistTemplateInfo;
        },
        getCurrentReportTemplateInfo: (state) => {
            if (state.allTemporaryTemplateInfo && state.allTemporaryTemplateInfo.length) {
                let current = state.allTemporaryTemplateInfo.filter(item => item.id === state.currentReportTemplateId);
                if (current && current.length) {
                    return current[0];
                }
            }
        },
        getBulkUploadCreativeParams: (state) => {
            return state.bulkUploadCreative;
        }
    },
    mutations: {
        setTableDataLoading(state, flag) {
            state.tableDataLoading = flag;
        },
        setChartDataLoading(state, flag) {
            state.chartDataLoading = flag;
        },
        setPermissionDialogVisible(state, flag) {
            state.permissionDialogVisible = flag;
        },
        setUserName(state, userName) {
            state.userName = userName;
        },
        setPermissionStatus(state, hasPermission) {
            state.hasPermission = hasPermission;
        },
        setPermissionList(state, permissionList) {
            state.permissionList = permissionList;
        },
        switchLang(state, lang) {
            // state.lang = lang;
            // window.app.$i18n.locale = lang;
            // localStorage.setItem('lang', lang);
            let webLang = lang === 'zh_CN' ? 'cn' : 'en';
            state.lang = webLang;
            localStorage.setItem('lang', webLang);
        },
        setUserId(state, userId) {
            state.userId = userId;
            localStorage.setItem('userId', userId);
        },
        // 开户信息保存
        setMediaList(state) {
            var mediaList = sessionStorage.getItem('mediaList');
            state.createAccountInfo.mediaList = mediaList;
        },
        // 开户信息保存
        setaccountInfoList(state) {
            var infoList = sessionStorage.getItem('infoList');
            state.createAccountInfo.accountInfoList = infoList;
        },
        // 开户信息保存
        setTargetSetting(state) {
            var targetSetting = sessionStorage.getItem('targetSetting');
            state.createAccountInfo.targetSetting = targetSetting;
        },
        setDownloadList(state) {
            var list = localStorage.getItem('downloadList');
            state.dowloadList = list ? JSON.parse(list) : undefined;
        },
        setDownloadStatus(state, flag) {
            state.createDownloadJob = flag;
        },
        setReportTemplate(state, list) {
            state.reportTemplateList = list;
        },
        setCurrentReportTemplateId(state, id) {
            state.currentReportTemplateId = id;
        },
        setAllTemporaryReportTemplate(state, list) {
            state.allTemporaryTemplateInfo = JSON.parse(JSON.stringify(list));
        },
        setAllExistReportTemplate(state, list) {
            state.allExistTemplateInfo = list;
        },
        setBulkUploadCreativeParams(state, infoObj) {
            state.bulkUploadCreative = Object.assign({}, state.bulkUploadCreative, infoObj);
        }
    },
    actions: {
        // 保存选择的媒体平台列表
        getMediaList(context, mediaList) {
            context.commit('setMediaList', mediaList);
        },
        // 保存开户信息
        getaccountInfoList(context, form) {
            context.commit('setaccountInfoList', form);
        },
        // 保存设置的目标信息
        getTargetSetting(context, form) {
            context.commit('setTargetSetting', form);
        },
        getCurrentDownloadList(context, list) {
            context.commit('setDownloadList', list);
        }
    }
});



// WEBPACK FOOTER //
// ./src/store.js